export default __webpack_public_path__ + "static/media/openWhite.90518084.svg";